import React from 'react'
import MainMenuComponent from '../../../Components/Menus/MainMenuComponent'

const SocialMediaResearchPage = () => {
  return (
    <MainMenuComponent menuName={'strategist'} />
  )
}

export default SocialMediaResearchPage